module.exports = __webpack_public_path__ + "img/SelectMemberPackage.ad6c93a8.svg";